import { ReactElement } from 'react';
import { Progress, Space } from 'antd';
import { lang } from 'zf-infra';
import { ImageProgressProps } from './types';

import styles from './style.module.less';

export function ImageProgress({ percent = 0 }: ImageProgressProps): ReactElement | null {
  return (
    <div className={styles.progress}>
      <Space wrap>
        <Progress
          type='circle'
          percent={lang.toFixed(percent * 100, 0)}
          strokeColor='white'
          size={40}
          format={() => <div className={styles.progressText}>{percent * 100}%</div>} />
      </Space>
    </div>
  );
}
